import { render, staticRenderFns } from "./InsertUrl.vue?vue&type=template&id=866969ac&lang=pug"
import script from "./InsertUrl.vue?vue&type=script&lang=js"
export * from "./InsertUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports